<template>
    <div class="home-container">
        <div class="hotel-header">
            <img src="https://1.nofetel.com/file/2023/12/11/033253a4-f22e-4e56-8ff0-b834963e5e66.png" alt="">
            <el-select v-model="searchForm.hotelId" placeholder="请选择酒店名称" filterable style="width: 160px" remote :remote-method="remoteMethod" :loading="loading" @change="handleSearch">
                <el-option v-for="item in hotelList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <i class="el-icon-arrow-down"></i>
        </div>

        <div class="home-card">
            <div class="card-item">
                <div class="card-title">营业情况</div>
                <div class="card-marker">今日</div>
                <div class="card-list">
                    <div class="item">
                        <div class="title">
                            <span>今日营收</span>
                            <el-tooltip class="item" effect="dark" content="截止当前时间段内所有已入住的订单总价之和" placement="top">
                                <i class="el-icon-info"></i>
                            </el-tooltip>
                        </div>
                        <div class="content">{{ totalData.revenueToday || 0 }}元</div>
                    </div>
                    <div class="item">
                        <div class="title">
                            <span>今日入住人次</span>
                            <el-tooltip class="item" effect="dark" content="截止当前时间段内所有已入住登记人次" placement="top">
                                <i class="el-icon-info"></i>
                            </el-tooltip>
                        </div>
                        <div class="content">{{ totalData.occupancyToday || 0 }}</div>
                    </div>
                    <div class="item">
                        <div class="title">
                            <span>今日入住率</span>
                            <el-tooltip class="item" effect="dark" content="截止当前时间段所有出售房间/总可售房间数" placement="top">
                                <i class="el-icon-info"></i>
                            </el-tooltip>
                        </div>
                        <div class="content">{{ totalData.occupancyRateToday || 0 }}%</div>
                    </div>
                </div>
            </div>

            <div class="card-item">
                <div class="card-title" style="opacity: 0;"></div>
                <div class="card-marker">综合</div>
                <div class="card-list">
                    <div class="item">
                        <div class="title">
                            <span>总营收数</span>
                            <el-tooltip class="item" effect="dark" content="所有已入住的订单总价之和" placement="top">
                                <i class="el-icon-info"></i>
                            </el-tooltip>
                        </div>
                        <div class="content">{{ totalData.revenue || 0 }}元</div>
                    </div>
                    <div class="item">
                        <div class="title">
                            <span>总入住人数</span>
                            <el-tooltip class="item" effect="dark" content="所有已入住登记人次" placement="top">
                                <i class="el-icon-info"></i>
                            </el-tooltip>
                        </div>
                        <div class="content">{{ totalData.occupancy || 0 }}</div>
                    </div>
                    <div class="item">
                        <div class="title">
                            <span>入住率</span>
                            <el-tooltip class="item" effect="dark" content="累计出售房间/总可售房间数" placement="top">
                                <i class="el-icon-info"></i>
                            </el-tooltip>
                        </div>
                        <div class="content">{{ totalData.occupancyRate || 0 }}%</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="home-card">
            <div class="card-item" style="margin: 0;">
                <div class="card-title">入住概览</div>
                <el-table border size="small" style="width:100%;margin-top:10px;" :data="tableData" v-loading="isLoading"
                    element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)">
                    <el-table-column type="index" label="#" align="center" width="60"></el-table-column>
                    <el-table-column prop="orderNo" label="订单号" align="center"></el-table-column>
                    <el-table-column prop="roomTypeName" label="房型" align="center"></el-table-column>
                    <el-table-column prop="floor" label="楼层" align="center"></el-table-column>
                    <el-table-column prop="roomNo" label="房间" align="center"></el-table-column>
                    <el-table-column prop="customerName" label="入住人" align="center"></el-table-column>
                    <el-table-column prop="days" label="入住天数" align="center"></el-table-column>
                    <el-table-column prop="lastPay" label="房费" align="center"></el-table-column>
                    <el-table-column prop="status" label="状态" align="center"  width="100">
                        <template slot-scope="{ row }">
                            <el-tag type="danger" size="mini" v-if="row.status == 2 || row.status == 6">{{ row.statusDesc }}</el-tag>
                            <el-tag type="primary" size="mini" v-else>{{ row.statusDesc }}</el-tag>
                        </template>
                    </el-table-column>
                </el-table>

                <el-pagination @size-change="handleChangeSize" @current-change="handleChangePage"
                    style="text-align:right;margin-top:10px;" :current-page="searchForm.pageNumber" :page-sizes="[10, 20, 50]"
                    :page-size="searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "homePage",
    data() {
        return {
            totalData: {},
            loading: false,
            hotelList: [],
            isLoading: false,
            searchForm: {
                hotelId: "",
                pageNumber: 1,
                pageSize: 10
            },
            tableData: [],
            total: 0

        }
    },
    created() {
        this.getHotelList("", 1);
    },
    methods: {
        handleSearch() {
            this.searchForm.pageNumber = 1;
            this.getTableData();
        },
        handleChangePage(page) {
            this.searchForm.pageNumber = page;
            this.getTableData();
        },

        handleChangeSize(size) {
            this.searchForm.pageNumber = 1;
            this.searchForm.pageSize = size;
            this.getTableData();
        },
        getTableData() {
            this.isLoading = true;
            this.getRequest("/api/roomOrder/pageAndCount", this.searchForm)
            .then(res => {
                this.isLoading = false;
                let data = res.data;
                if(data.code == 200) {
                    this.totalData = data.data;
                    this.tableData = data.data.page.records;
                    this.total = data.data.page.total;
                }
            })
        },
        remoteMethod(name) {
            if(name) {
                this.getHotelList(name);
            }
        },
        getHotelList(name,key) {
            this.getRequest("/api/hotel/page", {
                pageSize: 10,
                name: name || ''
            }).then(res => {
                let data = res.data;
                if(data.code == 200) {
                    this.hotelList = data.data.records;
                    if(key && this.hotelList.length) {
                        this.searchForm.hotelId = this.hotelList[0].id;
                        this.getTableData();
                    }
                }
            })
        },
    }
}
</script>

<style lang="less">
.home-container {
    .hotel-header {
        display: flex;
        align-items: center;
        img {
            width: 18px;
            height: 18px;
        }

        .el-input__inner {
            border: 0!important;
            background-color: transparent;
        }

        i {
            font-size: 16px;
        }
    }
    .home-card {
        display: flex;
        justify-content: space-between;
        font-size: 13px;
        margin-top: 20px;

        .card-item {
            flex: 1;
            background: #FFFFFF;
            border-radius: 12px;
            padding: 0 15px;
            padding-bottom: 25px;
            position: relative;
            &:first-child {
                margin-right: 20px;
            }

            .card-title {
                padding: 8px 0;
                font-size: 15px;
                display: flex;
                align-items: center;

                &::before {
                    display: block;
                    content: "";
                    width: 3px;
                    height: 16px;
                    background: #C4DFFF;
                    border-radius: 3px;
                    margin-right: 5px;
                }
            }

            .card-marker {
                position: absolute;
                right: 0;
                top: 0;
                width: 50px;
                height: 25px;
                line-height: 25px;
                background: rgba(39, 73, 163, .2);
                border-radius: 0px 12px 0px 12px;
                text-align: center;
                color: #2749A3;
            }

            .card-list {
                display: flex;
                justify-content: space-around;
                text-align: center;
                .item {
                    .title {
                        color: #999999;
                        font-size: 12px;

                        span {
                            margin-right: 5px;
                        }

                        i {
                            font-size: 14px;
                            cursor: pointer;
                        }
                    }

                    .content {
                        padding-top: 10px;
                        height: 39px;
                        line-height: 39px;
                        font-size: 28px;
                        font-weight: 600;
                        color: #333333;
                        line-height: 33px;
                    }
                }
            }
        }
    }
}
    
</style>